import { Irol } from "src/utils/roles/roles";
import { OpcionSelect } from "src/components/input/TextInput";
import { Ipageable } from "./general";

// Usuarios

export type IusuarioSistemaResponse = {
	usuarioId: string
	identificacion: string
	nombres: string
	apellidos: string
	correo: string
	numeroCelular: string
  };


  export const usuariosRespToOpcionSelect = (usuarios: IusuarioSistemaResponse[]): OpcionSelect[] => {
	return usuarios.map((usuario) => ({
	  valor: usuario.usuarioId,
	  label: `${usuario.nombres} ${usuario.apellidos}`,
	}));
  }

/// JUPITER
// Tipos para el registro de usuarios
export type IregistroUsuarioRequest = {
	tipoIdentificacion: string;
	identificacion: string;
	nombres: string;
	apellidos: string;
	correo: string;
	correoAlterno?: string;
	contrasena?: string;
	unidadId?: string;
	celular: string;
	aceptaTerminos?: boolean;
};

export type IregistroUsuarioResponse = Record<string, unknown>;

// Usuarios
export type IobtenerUsuariosRequest = {
	unidadId: string;
	textoSearch: string;
	paginador?: Ipageable;
};

export type IusuarioResponse = {
	usuarioId: string
	identificacion: string
	tipoIdentificacion: string
	nombres: string
	apellidos: string
	correo: boolean
	correoAlterno: boolean
	unidadId: string
	roles?: string
	esActivo: boolean
};

export type IobtenerUsuariosResponse = {
	result: IusuarioResponse[];
	total: number;
	page: number;
	returnedRecords: number;
};

// PERSONAS NATURALES

// Obtener Personas Naturales
export type IobtenerPersonasNaturalesRequest = {
	textoSearch: string;
	paginador?: Ipageable;
};


export type IpersonaNaturalResponse = {
	personaNaturalId: string
	nombres: string
	apellidos: string
	tipoIdentificacion: string
	identificacion: string
	correoAlterno: string
	celular: string
	correo: string
	esActivo: boolean
	tieneUsuariosUnidades: boolean
};

export type IobtenerPersonasNaturalesResponse = {
	result: IpersonaNaturalResponse[];
	total: number;
	page: number;
	returnedRecords: number;
};

// Guardar persona o usuario
export type IguardarPersonaNaturalRequest = {
	tipoIdentificacion: string;
	identificacion: string;
	nombres: string;
	apellidos: string;
	correo: string;
	contrasena?: string;
	celular: string;
	correoAlterno: string;
	municipioId: string;
	direccionResidencia: string;
	unidadId: string;
};

export type Acceso = {
	usuarioAccesoId: string
	tipoRecurso: string
	recursoId: string
	rol: string
	fechaInicio: string
	fechaFin: string
	esActivo: boolean
  }

export type IguardarPersonaNaturalResponse = {
	usuarioId: string
	tipoIdentificacion: string
	tipoPersona: string
	esInterno: boolean
	identificacion: string
	nombres: string
	apellidos: string
	correoAlterno: string
	celular: string
	correo: string
	municipioId: string
	direccionResidencia: string
	usuariounidadIdAutenticado: string
	esActivo: boolean
	accesos: Acceso[]
  };


// Obtener persona natural por identificación
export type IpersonaNaturalPorIdentificacionRequest = {
	identificacion: string;
	tipoIdentificacion: string;
};

export type IpersonaNaturalMinResponse = {
	usuarioId: string
	nombres: string
	esInterno: boolean
};

// Obtener usuario por id
export type IusuarioPorIdRequest = {
	usuarioId: string;
};

export type IusuarioPorIdResponse = {
	usuarioId: string;
	tipoIdentificacion: string;
	tipoPersona: string;
	esInterno: boolean;
	identificacion: string;
	nombres: string;
	apellidos: string;
	correo: string;
	celular: string;
	correoAlterno: string;
	paisId: string;
	departamentoId: string;
	municipioId: string;
	direccionResidencia: string;
	esActivo: boolean;
	accesos: Acceso[];
  };

// Tipos para  la actualización de datos personales
export type IactualizarDatosPersonalesRequest = {
	usuarioId: string;
	tipoIdentificacion: string;
	identificacion: string;
	nombres: string;
	apellidos: string;
	correo: string;
	correoAlterno?: string;
	celular: string;
	municipioId: string;
	direccionResidencia: string;
};

// Obtener usuario por unidad
export type IusuarioPorUnidadRequest = {
	unidadId: string;
	usuarioId: string;
};

export type  IusuarioUnidadResponse = {
	usuarioId: string;
	tipoIdentificacion: string;
	tipoPersona: string;
	esInterno: boolean;
	identificacion: string;
	nombres: string;
	apellidos: string;
	correo: string;
	celular: string;
	correoAlterno: string;
	municipioId: string;
	direccionResidencia: string;
	esActivo: boolean;
	accesos: Acceso[];
  }

export type IusuarioPorUnidadResponse = {
	usuario: IusuarioUnidadResponse;
	unidadId: string;
	correoProceso: string;
  };

// Guardar usuario por unidad
export type IusuarioPorUnidadSaveRequest = {
	unidadId: string;
	usuarioId: string;
	correoProceso?: string;
};

// Obtener personas por identificación
export type IpersonaPorIdentificacionRequest = {
	identificacion: string;
	tipoIdentificacion: string;
	tipoPersona?: string;
};

export type IpersonaMinResponse = {
	personaNaturalId: string
	tipoIdentificacion: string
	identificacion: string
	nombres: string
	apellidos: string
	tipoPersona: string
	esInterno: boolean
	correo: string
};

// Activar o inactivar usuario en unidad
export type IactivarInactivarUsuarioEnUnidadRequest = {
	usuarioId: string;
	unidadId: string;
};

// Crear acceso de usuario
export type IcrearAccesoUsuarioRequest = {
	usuarioId: string;
	unidadId: string;
	recursoId: string;
	rol: string;
	fechaInicio: string;
	fechaFin: string;
};


// Obtener accesos de usuario en unidad
export type IaccesosUsuarioUnidadRequest = {
	usuarioId: string;
	unidadId: string;
};

export type IdetalleAcceso = {
	usuarioAccesoId: string
	tipoRecurso: string
	recursoId: string
	rol: string
	fechaInicio: string
	fechaFin: string
	esActivo: boolean
  }

// Obtener usuario vinculado a una persona
export type IusuarioPorPersonaRequest = {
	usuarioId: string;
};

export type IusuarioPorPersonaResponse = {
	usuarioId: string
	unidadId: string
	nombreUnidad: string
	correoProceso: string
	roles: string
  };

  // Obtener participantes de proyecto
export type IsearchRequestParticipantes = {
    rol: Irol,
    fechaInicio: string,
    fechaFin: string
}

export type IobtenerParticipantesRequest = {
    proyectoId: string,
    paginador: Ipageable
}

export type IparticipanteItemResponse = {
    usuarioAccesoId: string
	usuarioId: string
    tipoIdentificacion: string
    identificacion: string
    nombres: string
    apellidos: string
    fechaInicio: string
    fechaFin: string
	rol: Irol
	correo: string
	correoProceso: string
	esActivo: boolean
}

export type IobtenerParticipantesResponse = {
    result: IparticipanteItemResponse[],
    total: number,
    page: number,
    returnedRecords: number,
}
